'use client'

import { Reveal } from '@/components/motion-primitives'
import { Icon } from '@/components/icon'

const STEPS = [
  {
    step: '01',
    title: 'Connect',
    body: 'Integrate once with our APIs or dashboard. Provision wallets, virtual accounts and banking rails in minutes.',
    icon: 'Code2',
  },
  {
    step: '02',
    title: 'Move Money',
    body: 'Send, receive and convert across currencies and stablecoins. Rombex orchestrates the optimal rail automatically.',
    icon: 'Send',
  },
  {
    step: '03',
    title: 'Scale Globally',
    body: 'Expand into new markets with local presence, compliance and settlement handled for you.',
    icon: 'Globe2',
  },
]

export function HowItWorks() {
  return (
    <section className="bg-background py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-wider text-brand">How it works</p>
          <h2 className="mt-3 text-balance text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
            Live in three steps
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.step} delay={i * 0.1}>
              <div className="group relative h-full overflow-hidden rounded-2xl border border-border bg-card p-8 transition-shadow hover:shadow-lg">
                <div className="flex items-center justify-between">
                  <span className="flex size-12 items-center justify-center rounded-xl bg-brand/10 text-brand transition-colors group-hover:bg-brand group-hover:text-brand-foreground">
                    <Icon name={s.icon} className="size-6" />
                  </span>
                  <span className="text-4xl font-semibold text-border">{s.step}</span>
                </div>
                <h3 className="mt-6 text-xl font-semibold text-foreground">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
